<template>
  <main>
    <div class="main-wrapper">
      <div class="center-wrapper">
        <Transition name="slide-fade">
          <div class="inner" v-if="stage == 1">
            <div class="header">
              <img class="img1" src="./assets/images/txt_header.png" alt="" />
              <img class="img2" src="./assets/images/txt_win1.svg" alt="" />
            </div>
            <div class="game-container">
              <div class="game">
                <div
                  class="card"
                  @click="flip(item, $event)"
                  v-for="(item, index) in arr"
                  :data-value="item"
                >
                  <div class="card-inner">
                    <div class="front"></div>
                    <div class="back"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer">
              <img class="img3" src="./assets/images/txt_find.svg" alt="" />

              <div class="timer-wrapper">
                <img class="timer-text" src="./assets/images/timer.svg" alt="" />
                <div class="timer">{{ showTime }}</div>
                <img class="timer-left" src="./assets/images/timerleft.svg" alt="" />
              </div>
              <a
                href="https://www.mojemincovna.cz/uploads/mailing/Pravidla-hry-022024.pdf"
                target="_blank"
                class="rules"
              >
                <img src="./assets/images/txt_rules.svg" alt="" />
              </a>
              <img class="img4" src="./assets/images/disclaimer.svg" alt="" />
            </div>
          </div>
        </Transition>
        <div class="inner s2" v-if="stage == 2">
          <img class="txtA" src="./assets/images/header2.png" alt="" />
          <img class="txtB" src="./assets/images/txt_win2.svg" alt="" />
          <div class="coin-container">
            <img class="coin1" src="./assets/images/coin1.png" alt="" />
            <img class="coin2" src="./assets/images/coin2.png" alt="" />
            <img src="./assets/images/shine.png" class="shine1" />
            <img src="./assets/images/shine.png" class="shine2" />
          </div>
          <img class="bar" src="./assets/images/label_gold.svg" alt="" />
          <img class="price" src="./assets/images/txt_price.svg" alt="" />
          <img class="replica" src="./assets/images/bonus.png" alt="" />
          <img class="note" src="./assets/images/banknote.png" alt="" />
          <div class="take-container">
            <img class="arrow" src="./assets/images/arrows.gif" alt="" />
            <a class="button" href="https://www.mojemincovna.cz/double-eagle1933">
              <img class="btn" src="./assets/images/btn.png" alt="" />
            </a>
            <img class="arrow" src="./assets/images/arrows.gif" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="full-screen-overlay" v-if="!active">
      <div class="badge-container">
        <img src="./assets/images/limit.svg" class="badge" @click="resetGame()" />
      </div>
    </div>
  </main>
</template>

<script setup>
import $ from 'jquery'

import { ref, watch, onMounted } from 'vue'

const matches = {
  1: 9,
  2: 10,
  3: 7,
  4: 12,
  5: 11,
  6: 8,
  7: 3,
  8: 6,
  9: 1,
  10: 2,
  11: 5,
  12: 4
}

const shuffle = (array) => {
  let currentIndex = array.length,
    randomIndex

  // While there remain elements to shuffle.
  while (currentIndex > 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--

    // And swap it with the current element.
    ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
  }

  return array
}

const clicked = ref(null)

const inProgress = ref(false)

const score = ref(0)

const interval = ref(null)
const timer = ref(180)
const showTime = ref('3:00')

const active = ref(true)

const stage = ref(1)

const arr = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])

const flip = (item, event) => {
  let target = $(event.target)
  if (active.value) {
    if (!target.hasClass('card')) {
      target = target.parents('.card')
    }
    if (!inProgress.value && !target.hasClass('done') && !target.hasClass('flipped')) {
      target[0].classList.add('flipped')
      if (!clicked.value) {
        clicked.value = item
      } else {
        inProgress.value = true
        if (matches[clicked.value] == item) {
          score.value++
          clicked.value = null
          inProgress.value = false
          $('.flipped').addClass('done')
          $('.flipped').removeClass('flipped')
        } else {
          setTimeout(() => {
            $('.flipped').removeClass('flipped')
            inProgress.value = false
            clicked.value = null
          }, 1000)
        }
      }
    }
  }
}

watch(score, (val) => {
  if (val == 3) {
    clearInterval(interval.value)
    stage.value = 2
  }
})

onMounted(() => {
  arr.value = shuffle(arr.value)

  interval.value = setInterval(reduceTime, 1000)
})

const reduceTime = () => {
  timer.value -= 1
  showTime.value = secondsToMinutesAndSeconds(timer.value)
  if (timer.value == 0) {
    clearInterval(interval.value)
    active.value = false
  }
}

const secondsToMinutesAndSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  const formattedTime = `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  return formattedTime
}

const resetGame = () => {
  window.location.reload()
}
</script>

<style scoped></style>
